import { generatePath, Navigate, useParams } from "react-router-dom";

export default function SoothRedirect({ to }) {
  const params = useParams();
  return <Navigate to={generatePath(to, params)} replace />;
}
